import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../authentication/service/auth-guard.service';
import { AddNewProjectComponent } from './add-new-project/add-new-project.component';
import {ChatTestComponent} from './chat-test/chat-test.component';

const routes: Routes = [
  {
    path: 'buyer/addnewproject',
    component: AddNewProjectComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'buyer/chat',
    component: ChatTestComponent,
    canActivate: [AuthGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BuyerRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/buyer/buyer-routing.module.ts